import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestTanquesVirtuais({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquevirtual', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteTanquesVirtual({ payload }) {
  try {
    const { idtanquevirtual, params } = payload;

    yield call(api.delete, `tanquevirtual/${idtanquevirtual}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { tanquesvirtual, params } = payload;

    yield call(api.post, 'tanquevirtual', tanquesvirtual);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/tanquevirtual');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idtanquevirtual } = payload;

    const { data } = yield call(api.get, `tanquevirtual/${idtanquevirtual}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { tanquesvirtual, params } = payload;

    yield call(api.put, 'tanquevirtual', tanquesvirtual);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/tanquevirtual');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquevirtual', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@tanquesvirtual/TANQUESVIRTUAIS_IN_REQUEST',
    requestTanquesVirtuais
  ),
  takeLatest('@tanquesvirtual/DELETE_TANQUESVIRTUAL', deleteTanquesVirtual),
  takeLatest('@tanquesvirtual/SUCCESS_REMOVE', requestTanquesVirtuais),
  takeLatest('@tanquesvirtual/STORE_TANQUESVIRTUAL', store),
  takeLatest('@tanquesvirtual/FIND_TANQUESVIRTUAL', find),
  takeLatest('@tanquesvirtual/UPDATE_TANQUESVIRTUAL', update),
  takeLatest('@tanquesvirtual/RECORD_FILTERING', applyedFilters),
]);
